export async function sendForm( data, loading = true ) {
	let formData;

    if (data instanceof FormData) {
        formData = data;
    } else {
        formData = new FormData();
        if (data) {
            for (let key in data) {
                formData.append(key, data[key]);
            }
        }
    }

    try {
		if ( loading ) {
			window.dispatchEvent(new CustomEvent('show-page-loading'));
		}

        const response = await fetch(ajax.ajaxurl, {
            method: "POST",
            body: formData,
        });

        if (!response) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

		window.dispatchEvent(new CustomEvent('hide-page-loading'));
        return result;

    } catch (err) {
        console.error('Error during fetch:', err);
        throw err; // Znovu vyhodí chybu, aby ste ju mohli zachytiť vo volajúcej funkcii
    }
}
